import UnfoldMoreIcon from '@mui/icons-material/UnfoldMore';
import { IconButton } from '@mui/material';
export function OpenInFullButton({ onClick }: { onClick: () => void }) {
  return (
    <IconButton onClick={onClick} color='secondary'>
      <UnfoldMoreIcon sx={{ transform: 'rotate(45deg)' }} />
    </IconButton>
  );
}
